import Link from 'gatsby-link';
import React, { PureComponent } from 'react';
import { css } from '@emotion/core'
import { cx } from 'emotion'
import { containers, Grid } from 'style';
import { MethodsService } from 'utils';
import { HeroImage, Media } from '..';
import ClientComponent from './subcomponents/client.component';
import TeaserImageComponent from './subcomponents/image.component';
import TextWrapperComponent from './subcomponents/textwrapper.component';
import TitleComponent from './subcomponents/title.component';
import TagsComponent from './subcomponents/tags.component';

class FeaturedCase01Component extends PureComponent {
    constructor(props) {
        super(props);

        this.imageMaxWidth = 1080;
        this.imageMaxHeight = 720;

        this.box = React.createRef();
    }


    navigateToCase(event, slug) {
        const {
            teaserImageWide,
        } = this.props;
        event.preventDefault();
        MethodsService.getMethod('navigateWithTransition')(
            'toCase',
            <HeroImage
                image={teaserImageWide}
                fadein={false}
            />,
            this.box.current.getBoundingClientRect(),
            `/${slug}`
        );
    }
    render() {
        const {
            teaserTitle,
            teaserImageWide,
            teaserImageTall,
            client,
            hover,
            translateX,
            slug,
            services,
        } = this.props;

        return (
            <div id="FeaturedCase01Component">
                <TeaserImageComponent
                    data-cursor="focus"
                    data-cursor-persistance="200"
                    width="58%"
                    minWidth={255}
                    maxWidth={teaserImageWide.width}
                    maxHeight={teaserImageWide.height}
                    align="right"
                    /*removed innerRef*/ 
                    className={hover ? 'hover' : ''}>
                    <Link to={`/${slug}`} onClick={event => this.navigateToCase(event, slug)} className="no-underline">
                        {/* <Image
                sizes={{
                  ...teaserImageWide.sizes,
                  aspectRatio: this.imageMaxWidth / this.imageMaxHeight,
                }}
              /> */}
                        <div ref={this.box}><Media image={teaserImageWide || teaserImageTall} loop={true} /></div>
                        <TextWrapperComponent
                            data-cursor="focus"
                            data-cursor-persistance="200">
                            <ClientComponent
                                client={client}
                                translateX={translateX}
                            />
                            <TitleComponent
                                teaserTitle={teaserTitle}
                                translateX={translateX}
                            />
                            <TagsComponent
                                tags={services}
                                />
                        </TextWrapperComponent>
                    </Link>
                </TeaserImageComponent>
            </div>
        );
    }
}

const ImageWrapper = css`
    // width: ${100 / 18 * 10}vw;
    // @media (min-width: ${containers.ipad + 1}px) {
    //   width: 33.3vw;
    // }
`;


export default FeaturedCase01Component;
